import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "d-flex flex-wrap flex-stack mb-6" }
const _hoisted_3 = { class: "fw-bold my-2 d-flex flex-column" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "me-4" }
const _hoisted_6 = { class: "ms-1" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = {
  key: 0,
  class: "mb-11"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "d-flex gap-4" }
const _hoisted_12 = { class: "fw-bold mb-6" }
const _hoisted_13 = {
  key: 1,
  style: {"width":"392px"}
}
const _hoisted_14 = { class: "overlay-wrapper card-rounded min-h-225px overflow-hidden h-275px border border-1" }
const _hoisted_15 = { class: "w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200" }
const _hoisted_16 = {
  key: 0,
  class: "w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200"
}
const _hoisted_17 = {
  key: 1,
  class: "text-black-50 opacity-80 fs-1"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark card-rounded bg-opacity-25" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
], -1)
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold mb-6" }, "Historical Documents")
], -1)

import { onMounted, ref } from "vue";
import UserImageDoc from "./UserImageDoc.vue";
import UserPersonalInfos from "@/projects/tenant/modules/users/components/userDocument/UserPersonalInfos.vue";
import {
  VerificationDocumentTypes,
  VerificationStatusTypes,
} from "@/core/types/VerificationInfos";
import {
  ArrowLeftBold,
  ArrowRightBold,
  DocumentAdd,
} from "@element-plus/icons-vue";
import DocumentFileUploadModal from "@/projects/tenant/modules/users/components/modal/DocumentFileUploadModal.vue";
import UserImageIdsDoc from "@/projects/tenant/modules/users/components/UserImageIdsDoc.vue";
import UserService from "../services/UserService";
import { VerificationTypes } from "@/core/types/VerificationInfos";
import FinalizedKycModal from "./modal/FinalizedKycModal.vue";
import FinalizedAuKycModal from "./modal/FinalizedAuKycModal.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDocuments',
  props: {
    verificationDetails: {},
    verifyOperation: { type: Boolean },
    height: {},
    partyId: {}
  },
  emits: ["updateVerificationDetails"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const isLoading = ref(false);
const kycLoading = ref(false);
const historicalDocuments = ref<Array<any>>([]);
const isShowUserInfos = ref(false);
const finalizeKyc = ref({} as any);

const documentFileUploadModal =
  ref<InstanceType<typeof DocumentFileUploadModal>>();
const finalizedKycModal = ref<InstanceType<typeof FinalizedKycModal>>();
const finalizedAuKycModal = ref<InstanceType<typeof FinalizedAuKycModal>>();

const verificationDocuments = ref<Record<string, Array<any>>>({
  idFront: [],
  idBack: [],
  addressDocument: [],
  others: [],
});

const openDocumentFileUploadModal = () => {
  documentFileUploadModal.value?.show(props.verificationDetails.id);
};

const showFinalizedKyc = async () => {
  if (finalizeKyc.value["bg1"] == "" && finalizeKyc.value["bg2"] == "") {
    kycLoading.value = true;
    const userVerification = await UserService.queryVerifications({
      partyId: props.partyId,
    });
    const verificationDetails = await UserService.getVerificationById(
      userVerification.data[0].id
    );

    finalizeKyc.value.financialInfo = verificationDetails.financial ?? {};
    console.log(finalizeKyc.value);

    finalizedAuKycModal.value?.show(finalizeKyc.value);
    kycLoading.value = false;
    return;
  }
  kycLoading.value = true;
  finalizedKycModal.value?.show(finalizeKyc.value);
  kycLoading.value = false;
};

const getKycForm = async () => {
  try {
    const res = await UserService.queryVerifications({
      type: VerificationTypes.KycForm,
      status: VerificationStatusTypes.Approved,
      partyId: props.partyId,
    });
    if (res.data.length != 0) {
      finalizeKyc.value = await UserService.getKycForm(props.partyId);
    }
  } catch (e) {
    console.log(e);
  }
};

const initVerificationDocuments = async (_verificationDetails?: any) => {
  verificationDocuments.value = {
    idFront: [],
    idBack: [],
    addressDocument: [],
    others: [],
  };
  (_verificationDetails ?? props.verificationDetails)?.document?.forEach(
    (doc) =>
      ((
        {
          [VerificationDocumentTypes.IdFront]: () =>
            verificationDocuments.value.idFront.push(doc),
          [VerificationDocumentTypes.IdBack]: () =>
            verificationDocuments.value.idBack.push(doc),
          [VerificationDocumentTypes.Address]: () =>
            verificationDocuments.value.addressDocument.push(doc),
        }[doc.documentType] ??
        (() => verificationDocuments.value.others.push(doc))
      )())
  );

  Object.values(verificationDocuments.value).forEach((arr) => {
    arr.sort((x, y) => y.id - x.id);
  });

  try {
    const mediaList = ref([] as any);
    if (props.partyId != undefined && props.partyId != null) {
      mediaList.value = await UserService.getClientMediaList({
        partyId: props.partyId,
      });
    }

    const uniqueIds = [] as any;
    const verificationDoc = (_verificationDetails ?? props.verificationDetails)
      ?.document;

    if (verificationDoc?.length > 0) {
      for (const item of verificationDoc) {
        uniqueIds.push(item.guid);
      }
    }

    mediaList.value.data?.forEach((item) => {
      if (!uniqueIds.includes(item.guid)) {
        historicalDocuments.value.push(item);
      }
    });
  } catch (e) {
    console.log(e);
  }
};

const fileUploaded = async () => {
  emits("updateVerificationDetails");
};

onMounted(() => {
  initVerificationDocuments();
  if (props.partyId != undefined) getKycForm();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "overflow-auto",
      style: _normalizeStyle([{"flex":"1","overflow-y":"auto"}, {
        height: `${props.height ?? '100%'} !important`,
        'border-right': isShowUserInfos.value && `1px dashed #999`,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("tip.verifyDocuments")), 1),
            _createVNode(_component_el_button, {
              type: "primary",
              plain: "",
              onClick: openDocumentFileUploadModal
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DocumentAdd))
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("action.upload")), 1)
              ]),
              _: 1
            }),
            (
                _ctx.verificationDetails?.status !== _unref(VerificationStatusTypes).Approved
              )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!isShowUserInfos.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowUserInfos.value = true))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("action.showUserInfo")), 1),
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowRightBold))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isShowUserInfos.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowUserInfos.value = false))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("action.hideUserInfo")), 1),
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowLeftBold))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["justify-content-between", {
          'd-flex': !isShowUserInfos.value,
        }])
      }, [
        _createVNode(UserImageIdsDoc, {
          medias: verificationDocuments.value.idFront,
          title: _ctx.$t('tip.idFront'),
          context: verificationDocuments.value.idFront[0]?.context,
          descp: isShowUserInfos.value ? '' : _ctx.$t('tip.idRequirement'),
          "verification-details": _ctx.verificationDetails,
          onFileDeleted: fileUploaded
        }, null, 8, ["medias", "title", "context", "descp", "verification-details"]),
        _createVNode(UserImageIdsDoc, {
          medias: verificationDocuments.value.idBack,
          title: _ctx.$t('tip.idBack'),
          context: verificationDocuments.value.idBack[0]?.context,
          descp: isShowUserInfos.value ? '' : _ctx.$t('tip.idRequirement'),
          "verification-details": _ctx.verificationDetails,
          onFileDeleted: fileUploaded
        }, null, 8, ["medias", "title", "context", "descp", "verification-details"]),
        _createVNode(UserImageIdsDoc, {
          medias: verificationDocuments.value.addressDocument,
          title: _ctx.$t('tip.addressDocument'),
          context: verificationDocuments.value.addressDocument[0]?.context,
          descp: isShowUserInfos.value ? '' : _ctx.$t('tip.addressRequirement'),
          "verification-details": _ctx.verificationDetails,
          onFileDeleted: fileUploaded
        }, null, 8, ["medias", "title", "context", "descp", "verification-details"])
      ], 2),
      (verificationDocuments.value.others.length > 0)
        ? (_openBlock(), _createElementBlock("hr", _hoisted_9))
        : _createCommentVNode("", true),
      (
          verificationDocuments.value.others.length > 0 ||
          Object.keys(finalizeKyc.value).length != 0
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.$t("tip.additionalDocument")), 1)
            ]),
            (verificationDocuments.value.others.length > 0 && !isLoading.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["flex-wrap", {
            'd-flex': !isShowUserInfos.value,
          }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(verificationDocuments.value.others, (item, index) => {
                    return (_openBlock(), _createBlock(UserImageDoc, {
                      key: index,
                      class: "me-3",
                      title: item.context,
                      media: item,
                      onFileDeleted: fileUploaded,
                      "verification-details": _ctx.verificationDetails,
                      "enable-delete": ""
                    }, null, 8, ["title", "media", "verification-details"]))
                  }), 128))
                ], 2))
              : _createCommentVNode("", true),
            (Object.keys(finalizeKyc.value).length != 0 && !isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("a", {
                    onClick: showFinalizedKyc,
                    class: "d-block overlay mb-4",
                    "data-fslightbox": "lightbox-hot-sales",
                    href: "#"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        (kycLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(ScaleLoader, { color: '#ffc730' })
                            ]))
                          : (_openBlock(), _createElementBlock("h1", _hoisted_17, "KYC Form"))
                      ])
                    ]),
                    _hoisted_18
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (historicalDocuments.value.length > 0 && !isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", {
              class: _normalizeClass(["flex-wrap", {
            'd-flex': !isShowUserInfos.value,
          }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historicalDocuments.value, (item, index) => {
                return (_openBlock(), _createBlock(UserImageDoc, {
                  key: index,
                  class: "me-3",
                  title: item.context,
                  media: item,
                  onFileDeleted: fileUploaded,
                  "verification-details": _ctx.verificationDetails,
                  disabledAction: true,
                  "enable-delete": ""
                }, null, 8, ["title", "media", "verification-details"]))
              }), 128))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ], 4),
    (isShowUserInfos.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "",
          style: _normalizeStyle([{"flex":"1","height":"625px","overflow-y":"auto"}, {
        flex: isShowUserInfos.value ? '1.5' : '0',
        padding: '20px',
      }])
        }, [
          _createVNode(UserPersonalInfos, { "verification-details": _ctx.verificationDetails }, null, 8, ["verification-details"])
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(DocumentFileUploadModal, {
      ref_key: "documentFileUploadModal",
      ref: documentFileUploadModal,
      onRefresh: fileUploaded
    }, null, 512),
    _createVNode(FinalizedKycModal, {
      ref_key: "finalizedKycModal",
      ref: finalizedKycModal
    }, null, 512),
    _createVNode(FinalizedAuKycModal, {
      ref_key: "finalizedAuKycModal",
      ref: finalizedAuKycModal
    }, null, 512)
  ]))
}
}

})